// Implements: F-MCK-021
/**
 * How many people the "Personas con acceso" tab lists (mockup v3: the number on the tab): the owner
 * plus every explicit assignment that is not the owner. Read through the same query keys as the
 * panel, so both agree and the count follows a change at once. `null` while unknown, and for a
 * personal mockup, which reads no assignments (default P4-5).
 */

import { useQuery } from "@tanstack/react-query";

import { fetchMockupDetail } from "../../../shared/api/mockupDetail";
import { mockupAssignmentsKey, mockupDetailKey } from "../../../shared/api/queryKeys";
import { fetchAssignments } from "../api/accessApi";

export function useAccessCount(mockupId: string, enabled: boolean): number | null {
  const detail = useQuery({
    queryKey: mockupDetailKey(mockupId),
    queryFn: () => fetchMockupDetail(mockupId),
    enabled,
  });
  const data = detail.data;
  const organizationScoped = data !== undefined && data.scope_kind !== "personal" && data.organization_id !== null;
  const assignments = useQuery({
    queryKey: mockupAssignmentsKey(mockupId),
    queryFn: ({ signal }) => fetchAssignments(mockupId, signal),
    enabled: enabled && organizationScoped,
  });
  if (data === undefined || !organizationScoped || assignments.data === undefined) return null;
  const ownerId = data.owner_id;
  return 1 + assignments.data.filter((assignment) => assignment.user_id !== ownerId).length;
}
